import React from 'react';
import { useTranslation } from 'react-i18next';
import DailyDeviationIndicator from '@wix/da-ds/pkg/thumbs/DailyDeviationIndicator';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import s from './FloatingIndicators.scss';
var FloatingIndicators = function (_a) {
    var deviation = _a.deviation, showStatusIndicator = _a.showStatusIndicator;
    var t = useTranslation().t;
    var statusIndicatorType = showStatusIndicator &&
        (deviation.commission ? 'commission' : deviation.pcp ? 'pcp' : undefined);
    return (React.createElement("div", { className: s['root'] },
        deviation.dailyDeviation && (React.createElement(SimpleTooltip, { text: t('shop.card.tooltip.dailyDeviation'), usePortal: true },
            React.createElement(DailyDeviationIndicator, { size: "large", className: s['dd'] }))),
        statusIndicatorType && (React.createElement(SimpleTooltip, { text: t("shop.card.tooltip.".concat(statusIndicatorType)), usePortal: true },
            React.createElement(ThumbStatusIndicator, { type: statusIndicatorType, size: "medium", className: s['status-indicator'] })))));
};
FloatingIndicators.displayName = 'FloatingIndicators';
export default FloatingIndicators;
//# sourceMappingURL=FloatingIndicators.js.map